export const SUCCESS_COLOR = '#52c41a';
export const ERROR_COLOR = '#ff4d4f';
export const MONEY_COLOR = '#00a63e';